var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 207H308.6L256 47.9 203.4 207H32l140.2 97.9L117.6 464 256 365.4 394.4 464l-54.7-159.1L480 207z",
    fill: "currentColor"
  })));
};
export default SvgStar;